import { render } from "./insurance.vue?vue&type=template&id=4015936c&ts=true"
import script from "./insurance.vue?vue&type=script&lang=ts"
export * from "./insurance.vue?vue&type=script&lang=ts"

import "./insurance.vue?vue&type=style&index=0&id=4015936c&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__